//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_NDC_HISTORY = 'GET_REBATE_PROGRAM_NDC_HISTORY';
export const GET_ERROR_MSG_NDC_DETAILS = 'GET_ERROR_MSG_NDC_DETAILS';
export const HANDLE_ERROR_MESSAGE_FOR_G_INV = 'HANDLE_ERROR_MESSAGE_FOR_G_INV';
export const SET_SELECTED_INPUT_NDC_HISTORY = 'SET_SELECTED_INPUT_NDC_HISTORY';
export const SET_NDC_HISTORY_REPORT_DATA = 'SET_NDC_HISTORY_REPORT_DATA';
export const REFRESH_NDC_HISTORY = 'REFRESH_NDC_HISTORY';
export const REFRESH_NDC_HISTORY_DISPLAY = 'REFRESH_NDC_HISTORY_DISPLAY';
export const IS_LOADING = 'IS_LOADING';
export const SET_NDC_HISTORY_DISPUTE_CODE_DATA =
  'SET_NDC_HISTORY_DISPUTE_CODE_DATA';
export const SET_NDC_HISTORY_REPORT_DATA_ALL =
  'SET_NDC_HISTORY_REPORT_DATA_ALL';
export const SET_PAGINATION_INDEX_NDC_HISTORY =
  'SET_PAGINATION_INDEX_NDC_HISTORY';
export const SET_OPEN_MODAL = 'SET_OPEN_MODAL';
export const NDC_HIST_DETAIL_DISP = 'NDC_HIST_DETAIL_DISP';
export const NDC_SELECT_TYPE = 'NDC_SELECT_TYPE'